module.exports = __webpack_public_path__ + "media/static/icons/icon-reef--red-2d743dc2e68df0e08941910c617cfc0b.svg";